var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCart = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2472_2346)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M86.38 22.58C84.872 20.94 82.728 20 80.496 20H17.6L17.16 16.676C16.5 11.732 12.24 8 7.248 8H4.5C2.288 8 0.5 9.788 0.5 12C0.5 14.212 2.288 16 4.5 16H7.248C8.248 16 9.1 16.748 9.232 17.736L15.38 63.848C16.3 70.776 22.264 76 29.252 76H71.64C78.864 76 84.992 70.364 85.592 63.164L88.472 28.66C88.652 26.436 87.892 24.22 86.38 22.58Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 84C36.9183 84 40.5 80.4183 40.5 76C40.5 71.5817 36.9183 68 32.5 68C28.0817 68 24.5 71.5817 24.5 76C24.5 80.4183 28.0817 84 32.5 84Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5 84C72.9183 84 76.5 80.4183 76.5 76C76.5 71.5817 72.9183 68 68.5 68C64.0817 68 60.5 71.5817 60.5 76C60.5 80.4183 64.0817 84 68.5 84Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 20H50.46L39.34 8.77602C38.316 7.74002 36.64 7.74002 35.616 8.77602L24.5 20Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 20H75.112L60.288 5.03598C58.92 3.65598 56.692 3.65598 55.324 5.03598L40.5 20Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2472_2346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCart, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cart.ccfd5174.svg";
export { ForwardRef as ReactComponent };